import {
  USER_DELETE_FAIL,
  USER_DELETE_REQUEST,
  USER_DELETE_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_LIST_FAIL,
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_SUSPEND_FAIL,
  USER_SUSPEND_REQUEST,
  USER_SUSPEND_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_UPDATE_ROLE_FAIL,
  USER_UPDATE_ROLE_REQUEST,
  USER_UPDATE_ROLE_SUCCESS,
  VENDEUR_REGISTER_FAIL,
  VENDEUR_REGISTER_REQUEST,
  VENDEUR_REGISTER_SUCCESS,
} from '../constants/userConstants';

export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { loading: true };
    case USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case USER_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userUpdateRoleReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_UPDATE_ROLE_REQUEST:
      return { loading: true };
    case USER_UPDATE_ROLE_SUCCESS:
      return { loading: false, success: true, userInfo: action.payload };
    case USER_UPDATE_ROLE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_REGISTER_REQUEST:
      return { loading: true };
    case USER_REGISTER_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case USER_REGISTER_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userDetailsReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case USER_DETAILS_REQUEST:
      return { ...state, loading: true };
    case USER_DETAILS_SUCCESS:
      return { loading: false, user: action.payload };
    case USER_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userUpdateProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_UPDATE_PROFILE_REQUEST:
      return { loading: true };
    case USER_UPDATE_PROFILE_SUCCESS:
      return { loading: false, success: true, userInfo: action.payload };
    case USER_UPDATE_PROFILE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const vendeurRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case VENDEUR_REGISTER_REQUEST:
      return { loading: true };
    case VENDEUR_REGISTER_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case VENDEUR_REGISTER_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer pour l'état utilisateur
export const userReducer = (state = { userInfo: null }, action) => {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
    case USER_REGISTER_SUCCESS:
      return { ...state, userInfo: action.payload };
    case USER_LOGOUT:
      return { ...state, userInfo: null }; // Réinitialise l'état utilisateur
    default:
      return state;
  }
};
// src/reducers/userReducers.js

// Reducer pour la liste des utilisateurs
export const userListReducer = (state = { users: [] }, action) => {
  switch (action.type) {
    case USER_LIST_REQUEST:
      return { loading: true };
    case USER_LIST_SUCCESS:
      return { loading: false, users: action.payload };
    case USER_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer pour la suppression d'un utilisateur
export const userDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_DELETE_REQUEST:
      return { loading: true };
    case USER_DELETE_SUCCESS:
      return { loading: false, success: true };
    case USER_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};



// src/reducers/userReducers.js

export const userSuspendReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_SUSPEND_REQUEST:
      return { loading: true };
    case USER_SUSPEND_SUCCESS:
      return { loading: false, success: true };
    case USER_SUSPEND_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};